/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import PageBreadcrumbs, { THEMES } from "@ucs/Overrides/Components/PageBreadcrumbs";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    newsTitle: getCurrentPage(state).fields.title,
    overrideTitle: getCurrentPage(state).fields.overrideTitle,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const NewsTitle: React.FunctionComponent<Props> = ({ newsTitle, fields, overrideTitle }: Props) => (
    <StyledWrapper>
        <PageBreadcrumbs theme={THEMES.GRAY}></PageBreadcrumbs>
        <Typography
            variant="h1"
            as="h1"
            css={css`
                margin-top: 4px;
                margin-bottom: 50px;
            `}
        >
            {overrideTitle || newsTitle}
        </Typography>
    </StyledWrapper>
);

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(NewsTitle),
    definition: {
        group: "Common",
        icon: "NewsTitle",
    },
};

export default widgetModule;
